import Router, { useRouter } from 'next/router';
import { getPageEventNameV2 } from 'tracks/tracker';

import { createInviteRelation } from '@/api/growth';
import { getRefererInfo } from '@/api/mkt';
import Constants from '@/constants/const';
import { PageNameV2 } from '@/constants/track';
import { getLoginState } from '@/utils/common/user';
import { getCookie, setCookieToMemory } from '@/utils/cookie';

import usePageMountEffect from './usePageMountEffect';

const qs = require('qs');

type Props = {
  urls?: string[];
};

const REFERRAL_PAGE_NAMES = [
  PageNameV2.mweb_home,
  PageNameV2.mweb_collection,
  PageNameV2.mweb_lightning_deal,
  PageNameV2.mweb_category,
  PageNameV2.mweb_product,
  PageNameV2.mweb_invite_friend_landing,
  PageNameV2.mweb_event_landing,
  PageNameV2.mweb_mkpl_vendor_landing,
  PageNameV2.mweb_mkpl_vendor,
  PageNameV2.mweb_mkpl_waterfall,
  PageNameV2.mweb_cms_page,
  PageNameV2.mweb_loyalty_rewards_landing,
  PageNameV2.mweb_raffle_landing,
  PageNameV2.mweb_topx_list,
  PageNameV2.mweb_topx_chart_list,
  PageNameV2.mweb_search_result,
  PageNameV2.mweb_brand,
  PageNameV2.mweb_mkpl_coupon_landing,
  PageNameV2.mweb_mkpl_lightning_deal,
  PageNameV2.mweb_onboarding,
  PageNameV2.mweb_promotion_landing,
  PageNameV2.mweb_thursday_lower_minimum_landing
];

/**路由变化时同步userid参数到url，用以用户直接粘贴url分享的场景 */
const useReferralUrl = (props?: Props) => {
  const { urls = REFERRAL_PAGE_NAMES } = props || {};
  const router = useRouter();
  const handleRouteChange = (url: string) => {
    url = url.replace(Constants.LANGUAGE_REGEXP, '') || '/';
    const matched = urls.some(key => getPageEventNameV2(url) === key);
    if (!matched) return;
    const userId = getCookie(Constants.USER_ID);
    if (!+userId) return;
    const query = url?.split('?')?.[1] ?? '';
    const [noAnchorQuery, hash] = query?.split('#');
    let newUrl = qs.stringify(
      {
        ...{ ...qs.parse(noAnchorQuery), referral_id: +userId, __no_replace: 1 }
      },
      { addQueryPrefix: true }
    );
    newUrl = hash ? `${newUrl}#${hash}` : newUrl;
    window.history.replaceState(window.history.state, '', newUrl);
  };

  usePageMountEffect(() => {
    // 是返利联盟成员才添加url
    (async () => {
      if (getLoginState()) {
        const refererInfo = await getRefererInfo();
        if (refererInfo && refererInfo.result) {
          setCookieToMemory(Constants.IS_AFFILIATE, '1');
        } else {
          setCookieToMemory(Constants.IS_AFFILIATE, '0');
        }
      }
    })();

    const is_affiliate = getCookie(Constants.IS_AFFILIATE);
    if (!is_affiliate || is_affiliate === '0') return;
    handleRouteChange(router.asPath);
    Router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      Router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, []);

  /**普通分享，被分享者登陆后需要调用接口，保存分享关系 */
  usePageMountEffect(() => {
    const isLogin = getCookie(Constants.IS_LOGIN) === '1' ? true : false;
    const invitorId = getCookie(Constants.REFERRER_ID);
    if (!isLogin || !invitorId) return;
    createInviteRelation(invitorId);
  }, []);
};

export default useReferralUrl;
